import { withPrefix } from './';

const createAsyncTypes = (prefix: string, arr: string[]): {
    [k in string]: {
        REQUEST: string;
        SUCCESS: string;
        ERROR: string;
    }
} => arr.reduce((total, current) => ({
    ...total,
    [current]: {
        REQUEST: withPrefix(prefix, `${current}/REQUEST`),
        SUCCESS: withPrefix(prefix, `${current}/SUCCESS`),
        ERROR: withPrefix(prefix, `${current}/ERROR`)
    },
}), {});

export default createAsyncTypes;
